import { Script } from 'gatsby'

const MathJaxConfig = `
window.MathJax = {
  loader: {
    load: ['[tex]/ams', '[tex]/color', 'ui/lazy']
  },
  tex: {
    inlineMath: [['$', '$'], ['\\\\(', '\\\\)']],
    displayMath: [['$$', '$$'], ['\\\\[', '\\\\]']],
    processEscapes: true,
    processEnvironments: true,
    packages: {'[+]': ['ams', 'color']},
    tags: 'ams'
  }
};`

const MathJax = () => {
  return (
    <>
      <Script id="mathjax-config">{MathJaxConfig}</Script>
      <Script src="https://cdn.jsdelivr.net/npm/mathjax@3/es5/tex-chtml.js" />
    </>
  )
}

export default MathJax
